import Cookies from 'js-cookie';
import axios from 'axios';

const setUseHeader = (token) => {
    const headerUse = useHeader()  
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8"
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
    headerUse.value = headers;
  }

const clearClientAuth = () => {
    Cookies.remove('user', { path: '/' });
    Cookies.remove('token', { path: '/' });
    useUser().value = null;
    useUsers().value = null;
    setUseHeader();
}

const getUsers = async (userId)=>{
    const config = useRuntimeConfig();

    let token = Cookies.get('token');
    const users = useUsers(); 
 
    let headers =  {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8"
    };

    if(token){
        headers.Authorization = `Bearer ${token}` 
    }
    users.value = [];
             await axios({
                  url: `${config.public.apiBase}/rest/custom/users`,
                  method: "GET",
                  origin: true,
                withCredentials: true,
                headers: headers
              }).then(response => {     
                users.value = response.data?.data;
                // console.log("users", users.value)
              });
                  
}
export const getUser = async (trySuccess = false) => {

    let uc = Cookies.get('user');
    let token = Cookies.get('token');
    
    const config = useRuntimeConfig();

    // console.log("token",token)
    // const { isJsonString, goPath } = useCommon()
    const route = useRoute(); 
    const user = useUser(); 
    const users = useUsers();
    const adminMfaChallenge = useAdminMfaChallenge();

    if(token){
        setUseHeader(token);
    }
  
    if(uc && user.value && user.value?.id){ 
        if(user.value.U_Admin === "on" && (!users.value || users.value.length === 0)){
            getUsers(user.value.id)
        }

    }else{

        let headers =  {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
        };

        if(token){
            headers.Authorization = `Bearer ${token}` 
        }
  
            if (uc && uc.id) { 
                 
               
                 await axios({
                    url: `${config.public.apiBase}/api/custom/me`,
                    method: "GET",
                    origin: true,
                    withCredentials: true,
                    headers: headers
                  }).then(response => { 
                   
                    const res = response.data?.user;  
                    if(res && res.status!=false){
                            if (!res.U_Photo) {
                                res.U_Photo = "/image/user.png"
                            } 
                            if (res.U_Admin === "on") {
                                getUsers(res.id)
                            } 
                            if(!token){
                                Cookies.set('token', response.data?.token);
                                setUseHeader(response.data?.token);
                            }
                            user.value = res  
                   }else{
                            Cookies.set('user', '');
                            user.value = {}
                    }
                   
                  }).catch(err => {
                      clearClientAuth();
                      console.log("err", err)
                  });

            } else if(trySuccess || token || route.query?.redirected) {   
 
             
                await axios({ 
                    url:`${config.public.apiBase}/auth/login/success`,
                    method: "GET",
                    origin: true,
                    withCredentials: true,
                    headers: headers
                }).then(async (response) => {    
                    const res = response.data;
                     
                        if (res?.mfa_required && res?.challenge_id) {
                            // OAuth returns here after the provider redirect. Keep the
                            // pending challenge for the login page to render its code form.
                            adminMfaChallenge.value = res;
                        } else if(res && res.success){
                            if (res.user && !res.user.U_Photo) {
                                res.user.U_Photo = "/image/user.png"
                            }

                            if (res.user.U_Admin === "on") {
                                getUsers(res.user.id)
                            }
                             
                            if(!token){
                                Cookies.set('token', response.data?.token);
                                setUseHeader(response.data?.token);
                            }
                            // set referal, if not defined before
                             let ref =  Cookies.get('referral', '');
                        
                            if(ref && !res.user.U_Referral){
                                await axios({
                                    url:`${config.public.apiBase}/api/uye/${res.user.id}`,
                                    method: "PUT",
                                    data: {
                                        U_Referral: ref
                                    },
                                    withCredentials: true, 
                                }
                                ).then(async response => {   
                                        localStorage.removeItem("referral");
                                });

                            }
                            user.value = res.user; 
                            Cookies.set('user', user.value?.id);
                        }else{
                            clearClientAuth();
                        }
                    //}
                }).catch(err => {
                    clearClientAuth();
                    console.log("err", err)
                });
            }
     } 
     
    // const user = useUser()
    // console.log("getUser called", user.value)
    // try {
    //     const me = await $fetch('/api/me') 
    //     user.value = me
    //   } catch (err) {
    //     user.value = null
    //   }
}


export const signUpWithGoogle = async () => {
    const config = useRuntimeConfig();

    Cookies.set('user', '');
    let ref = localStorage.getItem("referral");
    console.log("ref", `${config.public.apiBase}`+"/auth/google?ref="+ref)
    window.open(`${config.public.apiBase}`+"/auth/google?ref="+ref, "_self");
}
export const signUpWithFacebook = async () => {
    const config = useRuntimeConfig();

    Cookies.set('user', '');
    let ref = localStorage.getItem("referral");
    window.open(`${config.public.apiBase}`+"/auth/facebook?ref="+ref, "_self");
}


export const useGoPath = (url)=> { 
    let r = useRouter();
    r.push({path:url})
};

export const askRole = (roles)=>{
    const user = useUser()
    if(user.value.U_Role=== "Master"){
        return true;
    }
    if(roles?.length > 0){
        return roles.includes(user.value.U_Role);
    }else{
        return false;
    }
}

export const signUpWithLocal = async (form) => {

    const config = useRuntimeConfig();
    const alert = useAlert();
    if (form.password && form.password) {

        return new Promise((resolve, reject) => {
        Cookies.set('user', '');

          axios({
            url:`${config.public.apiBase}/auth/local`,
            method: "POST", 
            data:form,
            origin: true,
            withCredentials: true,
            headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
            }
        }
        ).then(response => {    
           
            const loginUser = response.data?.user;
            const loginToken = response.data?.token;
            if(loginToken && loginUser?.id) {
                Cookies.set('user', loginUser.id, { path: '/', sameSite: 'lax', secure: location.protocol === 'https:' });
                Cookies.set('token', loginToken, { path: '/', sameSite: 'lax', secure: location.protocol === 'https:' });
                setUseHeader(loginToken);
                useUser().value = loginUser;
                if (loginUser.U_Admin === "on") {
                    getUsers(loginUser.id);
                }
                resolve(response.data)
            }else if (response.data?.mfa_required && response.data?.challenge_id) {
                // Admin accounts receive no token until the WhatsApp challenge is verified.
                // Let the login component move to its second step without clearing state.
                resolve(response.data)
            }else{
                clearClientAuth();
                alert.value = { 
                    text: response.data?.message || 'Bir hata oluştu. Bilgileri kontrol edip tekrar deneyin.',
                    show: true,
                    title: 'Hata', 
                    type: 'fail'
                }; 
                resolve(-1)
            }
        }).catch(error => {
            clearClientAuth();
            alert.value = {
                text: error.response?.data?.message || 'Giriş yapılamadı. Lütfen bilgilerinizi kontrol edip tekrar deneyin.',
                show: true,
                title: 'Hata',
                type: 'fail'
            };
            reject(error);
        }); 
    });
} 

};

export const signUpWithMobile = async (form) => {

    const config = useRuntimeConfig();

    if (form.code && form.code) {

        return new Promise((resolve, reject) => {
        Cookies.set('user', '');

          axios({
            url:`${config.public.apiBase}/auth/mobile`,
            method: "POST", 
            data:form,
            origin: true,
            withCredentials: true,
            headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
            }
        }
        ).then(response => {    
           
            if(response.data?.token) { 
                Cookies.set('user', response.data?.user?.id);
                Cookies.set('token', response.data?.token);
                setUseHeader(response.data?.token);
                getUser(true) 
                //     location.reload(); 
                resolve(response.data)
            }else{
                resolve(response.data)
            }
        }); 
    });
} 

};


export const iAmTalkingWith = async()=>{ 
 
};
